import React from "react"
import { Div } from "atomize"
import { motion } from "framer-motion"
import { theme } from "../settings/config"

// Mentre le lezioni arrivano si mostra la loro forma, non un messaggio: chi
// apre l'app vede subito che qualcosa sta per comparire, e dove. Un testo
// "sto cercando" dice la stessa cosa ma lascia la pagina vuota, e una
// pagina vuota per mezzo secondo sembra un'app senza dati.
const Bar = ({ w, h = "0.7rem", m }) => (
	<Div w={w} h={h} m={m} rounded="10px" bg={theme.colors.gray_light} />
)

// È anche la schermata di avvio dell'app (docs/interfaccia.md, "Il sito e
// l'app"): sotto la fascia arancione lascia un po' d'aria, perché attaccate
// alla fascia le forme sembrano schiacciate.
function LessonsSkeleton({ rows = 3 }) {
	return (
		<Div m={{ t: "1.5rem" }}>
			{Array.from({ length: rows }).map((_, index) => (
				<motion.div
					key={index}
					initial={{ opacity: 0.45 }}
					animate={{ opacity: [0.45, 0.85, 0.45] }}
					transition={{
						duration: 1.4,
						repeat: Infinity,
						ease: "easeInOut",
						// sfasate: l'onda si legge come un caricamento, tre cose
						// che lampeggiano insieme sembrano un errore
						delay: index * 0.15,
					}}>
					<Div
						bg={theme.colors.surface}
						rounded={theme.rounded["20px"]}
						shadow={theme.shadows.accent}
						p="1rem"
						m={{ x: "0.5rem", b: "0.75rem" }}
						d="flex"
						align="center"
						style={{ gap: "1rem" }}>
						{/* l'orario, a sinistra come nelle lezioni vere */}
						<Div style={{ flexShrink: 0 }}>
							<Bar w="3rem" h="0.9rem" />
						</Div>

						<Div style={{ flex: 1, minWidth: 0 }}>
							<Bar w="60%" h="0.9rem" m={{ b: "0.5rem" }} />
							<Bar w="40%" />
						</Div>

						{/* la pastiglia del campo */}
						<Div style={{ flexShrink: 0 }}>
							<Bar w="2rem" h="2rem" />
						</Div>
					</Div>
				</motion.div>
			))}
		</Div>
	)
}

export default LessonsSkeleton
